<script>
import BaseIframe from "@/components/BaseIframe.vue";
export default {
  name: "RightBarAdvertisement.vue",
  components: {
    BaseIframe
  }
}
</script>

<template>
  <div>
    <div class="right-bar-advertisement right-bar-advertisement--premium mb-10">
      <base-iframe :src="'/ads/placement/premium?_f=true'"
                   :show-header="false"
      />
    </div>
    <div class="right-bar-advertisement right-bar-advertisement--standard">
      <base-iframe :src="'/ads/placement/standard?_f=true'"
                   :show-header="false"
      />
    </div>
  </div>
</template>

<style lang="scss">
.right-bar-advertisement {
  width: 342px;
  height: 250px;
  overflow: hidden;

  iframe {
    position: relative !important;
  }

  &--premium {

  }
  &--standard {
    height: 310px;
  }
}
</style>
